import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _compact from 'lodash/compact';
import SVG from 'react-inlinesvg';
import alertIcon from '@lifesize/ux-assets/vectors/svgIcons/alert-outline.svg';
import launchIcon from '@lifesize/ux-assets/vectors/svgIcons/launch.svg';
import paletteIcon from '@lifesize/ux-assets/vectors/svgIcons/palette.svg';
import { FETCH_ERROR_TYPES } from 'constants/PluginConstants';
import classes from './CollaborationTools.module.scss';
import { getDomain } from 'utils/UrlUtil';

export class CollaborationTools extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      whiteboardHash: '',
      whiteboardError: ''
    };
  }

  handleOpenWhiteboard = () => {
    const whiteboardUrl = `https://wb.${getDomain()}?code=${this.state.whiteboardHash}`;
    if (this.props.isDesktop) {
      this.props.desktopOpenWhiteboard(whiteboardUrl);
    } else {
      this.props.webappOpenWhiteboard(whiteboardUrl);
    }
  };

  // For every request (opening of the whiteboard window) you need a new hash
  handleWhiteboardRequest = () => {
    const whiteboardWindow = window.lifesize.whiteboardWindow;
    if (this.state.whiteboardHash && whiteboardWindow && !whiteboardWindow.closed && !this.props.isDesktop) {
      // if the whiteboard window is already open, don't make a new request, just give it focus
      this.handleOpenWhiteboard();
    } else {
      // otherwise, clear the hash in state and request a new hash (the hash can be used only once for security reasons)
      this.setState(
        { whiteboardHash: '', whiteboardError: '' },
        () => {
          if (this.props.meetingUUID) {
            this.props.requestWhiteboard(this.props.meetingUUID, this.handleWhiteboardResponse);
          } else {
            this.handleWhiteboardResponse({ error: FETCH_ERROR_TYPES.NOT_SUPPORTED });
          }
        }
      );
    }
  };

  handleWhiteboardResponse = (response) => {
    if (response.data) {
      this.setState(
        { whiteboardHash: response.data },
        this.handleOpenWhiteboard
      );
    } else {
      this.setState(
        { whiteboardError: response.error }
      );
    }
  };

  renderError = () => {
    const { whiteboardError } = this.state;
    if (!whiteboardError) return null;

    const getErrorMessage = (errorType) => {
      switch(errorType) {
        case FETCH_ERROR_TYPES.NOT_SUPPORTED:
          return (
            <FormattedMessage
              id="components.inCall.collaborationToolsDrawer.whiteboardErrorNotSupported"
              defaultMessage="The whiteboard is not supported for this call."
            />
          );
        default: // 'SERVER'
          return (
            <FormattedMessage
              id="components.inCall.collaborationToolsDrawer.whiteboardErrorServer"
              defaultMessage="An error occurred while opening the whiteboard. Please try again."
            />
          );
      }
    }
    return (
      <section>
        <div className={classes.alert}>
          <SVG src={alertIcon} />
          {getErrorMessage(this.state.whiteboardError)}
        </div>
      </section>
    );
  }

  render() {
    const {
      isVisible,
    } = this.props;
    const containerClasses = _compact([
      classes.container,
      isVisible ? '' : classes.hiddenDrawer
    ]).join(' ');

    return (
      <div className={containerClasses}>
        <header>
          <h6>
            <FormattedMessage
              id="components.inCall.collaborationToolsDrawer.title"
              defaultMessage="Collaboration Tools"
            />
          </h6>
        </header>
        <div className={classes.details}>
          <section>
            <div className={classes.title}>
              <SVG src={paletteIcon} />
              <FormattedMessage
                id="components.inCall.collaborationToolsDrawer.sectionWhiteboard"
                defaultMessage="Whiteboard"
              />
              <div className={classes.badge}>
                <FormattedMessage
                  id="badge.beta"
                  defaultMessage="BETA"
                />
              </div>
            </div>
            <button className={classes.primaryButton} onClick={this.handleWhiteboardRequest}>
              <SVG src={launchIcon} />
              <FormattedMessage
                id="components.inCall.collaborationToolsDrawer.buttonOpenWhiteboard"
                defaultMessage="Open Whiteboard"
              />
            </button>
          </section>
          {this.renderError()}
        </div>
      </div>
    );
  }
}

CollaborationTools.propTypes = {
  desktopOpenWhiteboard: PT.func,
  isDesktop: PT.bool,
  isVisible: PT.bool,
  meetingUUID: PT.string,
  requestWhiteboard: PT.func,
  webappOpenWhiteboard: PT.func
};

export default CollaborationTools;
